import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CallContext } from "./api/models";
import { useDialerPullState } from "./dialerPullContext";

export function useLocationCallContext(
  clearOnUpdate: boolean = false,
): CallContext | undefined {
  const { setCallContext } = useDialerPullState();

  const location = useLocation();
  const { callContext: locationCallContext } = location.state
    ? (location.state as {
        callContext: CallContext;
      })
    : {};

  useEffect(() => {
    if (locationCallContext) {
      setCallContext(locationCallContext);
      if (clearOnUpdate) {
        window.history.replaceState(null, "");
      }
    }
  }, [locationCallContext, setCallContext, clearOnUpdate]);

  return locationCallContext;
}
